(() => {
  // Keep the mobile control in sync with Shopify's actual variant and loading state.
  const controls = new Map();
  const syncControls = () => {
    document.querySelectorAll('[data-rw-mobile-add]').forEach((trigger) => {
      const target = document.getElementById(trigger.dataset.rwMobileAdd);
      if (!target) { trigger.disabled = true; return; }
      if (controls.get(trigger)?.target === target) return;
      controls.get(trigger)?.observer.disconnect();
      const sync = () => {
        trigger.disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
        const label = target.querySelector('span')?.textContent.trim();
        if (label) trigger.textContent = label;
      };
      const observer = new MutationObserver(sync);
      observer.observe(target, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, characterData: true, subtree: true });
      controls.set(trigger, { target, observer });
      sync();
    });
    controls.forEach(({ observer }, trigger) => {
      if (!trigger.isConnected) { observer.disconnect(); controls.delete(trigger); }
    });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-rw-mobile-add]');
    if (!trigger || trigger.disabled) return;
    const target = document.getElementById(trigger.dataset.rwMobileAdd);
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    target.click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncControls, { once: true });
  else syncControls();
  document.addEventListener('shopify:section:load', syncControls);
  document.addEventListener('shopify:section:unload', syncControls);
})();
